<nav class="navbar navbar-expand-md navbar-dark bg-dark justify-content-center">
    <a [routerLink]="['']" class="navbar-brand mr-auto">
        <img [src]="(privateLabelLogo$ | async) || '../../../../assets/images/logo.png'" />
    </a>

    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#collapsingNavbar">
        <span class="navbar-toggler-icon"></span>
    </button>

    <div class="navbar-collapse collapse w-100" id="collapsingNavbar">
        <div class="nav navbar-nav ml-auto w-100 justify-content-end links" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
            <a class="btn btn-link" [ngClass]="{'u-hidden': !showSignIn}" [routerLink]="['/signin']">sign in</a>
            <a class="btn btn-link" [routerLink]="['/signup']" routerLinkActive='u-hidden'>sign up</a>
        </div>
    </div>
</nav>
